export const authKeys = {
  all: ['auth'] as const,
  currentUser: () => [...authKeys.all, 'current-user'] as const,
  hanwhaAccess: (uuid: string) =>
    [...authKeys.all, 'hanwha-access', uuid] as const,
  signout: () => [...authKeys.all, 'signout'] as const,
  policyAcceptance: (version: string) =>
    [...authKeys.all, 'policy-acceptance', version] as const,
} as const
